import React from 'react';
import Layout from '../components/layout/Layout';
import Accesos from '../components/accesos/Accesos';

export const AccesoPage = () => {
    return ( <Layout children={<Accesos />} /> )
}